import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Global-Services/common.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false,
})
export class HomeComponent implements OnInit {

  KeyContactList: []

  constructor(public gService: CommonService, ) { }

  ngOnInit() {
    this.GetDashboardKeyContactData();
  }

  GetDashboardKeyContactData() {
    this.gService.GetDashboardKeyContactData().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.KeyContactList = data;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

}
